import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import styles from './styles.scoped.css';

export default function GuideBox({ children, className, style, ...rest }) {
  return (
    <div
      {...rest}
      className={classNames(styles.container, className)}
      style={style}
    >
      {children}
    </div>
  );
}

GuideBox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};
